import $ from 'jquery';

export const init = () => {
	const table = $('.js-table');
	if (table.length < 1) return;
	table.each(function () {
		const item = $(this);
		item.find('th').each(function (index) {
			const text = $(this)[0].innerText;
			item.find('tbody tr').each(function () {
				const td = $(this).find('td')[index];
				const tdOriginal = td.innerHTML,
					tdHead = '<span class="table-fake-head u-hide@md">' + text + '</span>';
				td.innerHTML = tdHead + tdOriginal;
			});
		});
	});
};
